export enum PromoCodeErrorCodes {
  ALREADY_USED = 'ALREADY_USED',
  DATE_RANGE = 'DATE_RANGE',
  INVALID_PRODUCT = 'INVALID_PRODUCT',
  LIMIT_USAGE = 'LIMIT_USAGE',
  PAYMENT_GATEWAY_THRESHOLD = 'PAYMENT_GATEWAY_THRESHOLD',
  PROMOCODE_DISABLED = 'PROMOCODE_DISABLED',
  TOO_MANY_CODES = 'TOO_MANY_CODES',
  INCOMPATIBLE_WITH_COMPANY_DISCOUNT = 'INCOMPATIBLE_WITH_COMPANY_DISCOUNT',
}
